import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Combobox, type ComboboxItem } from './Combobox';
import { COUNTRIES } from '@/lib/countries';

interface Props {
  value: string;
  onChange: (code: string) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * Searchable popover country picker. Uses COUNTRIES from
 * lib/countries.ts — the same source the cross-border headcount UI
 * + reports table use, so flags and names never drift.
 */
export function CountryPicker({ value, onChange, disabled, className }: Props) {
  const { t } = useTranslation();
  const items: ComboboxItem<string>[] = useMemo(
    () => COUNTRIES.map((c) => ({
      value: c.code,
      label: c.englishName,
      icon: c.flag,
      badge: c.code,
      searchAliases: [c.code],
    })),
    [],
  );
  return (
    <Combobox
      value={value.toUpperCase()}
      onChange={(v) => onChange(v.toUpperCase())}
      items={items}
      disabled={disabled}
      className={className}
      placeholder={t('common.selectCountry', { defaultValue: 'Select country…' })}
      searchPlaceholder={t('common.searchCountry', { defaultValue: 'Search country…' })}
    />
  );
}
